
import { createSlice } from '@reduxjs/toolkit'

const sidebarslice = createSlice({
  name: 'sidebarslice',
  initialState: {
    value: '',
  },
  reducers: {
    toggleValue: (state) => {
        state.value =  !state.value
    },
    setValue : (state, action) =>{
       state.value = action.payload
    }
  },
})

export const { toggleValue, setValue } = sidebarslice.actions
export default sidebarslice.reducer